import Login from '../views/login';

var authRoutes = [
    { path: '/authentication/login', name: 'Login with Firebase', icon: 'mdi mdi-account-key', component: Login },
];
export default authRoutes; 